// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"31":"c6b010a7","54":"84fd519c","333":"e2fbde83","566":"7be88f34","588":"c29e3f86","692":"e9aabdf7","808":"fffcfa0b","896":"37ad4a70"}[chunkId] + ".css";
};